type ProductFruits =
  | {
      api?: {
        feedback?: { showModal: () => undefined };
        inAppCenter?: { isOpened?: () => boolean };
      };
      feedback?: { shownPopupEl?: Element | null };
      services?: { destroy?: () => void };
    }
  | undefined;

function getProductFruits(): ProductFruits {
  return window.productFruits;
}

export function isProductFruitsOpen(): boolean {
  try {
    const productFruits = getProductFruits();
    return (
      !!productFruits?.api?.inAppCenter?.isOpened?.() ||
      !!productFruits?.feedback?.shownPopupEl
    );
  } catch {
    return false;
  }
}

export function destroyProductFruits() {
  const productFruits = getProductFruits();
  if (productFruits?.services?.destroy) productFruits.services.destroy();
}
